<template>
  <custom-dialog width="1280px" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <div class="item-title">{{ $t('dms_changeDeviceDialog.yuan_she_bei_xin_xi') }}</div>
      <div class="table-bd">
        <custom-table tableCode="stock_change_old" :data="rowTableList" @filter="filterChange" @sort="sortChange"
          :slots="['returnOrg']">
          <template slot="returnOrg">
            <custom-select v-model="form.oldConsigneeOrgId" url="OrganReturn" :params="{ excludeOrgId: model.row.orgId }"
              :props="{ label: 'orgName', value: 'orgId' }" width="220px"></custom-select>
          </template>
        </custom-table>
      </div>
      <div class="item-title" style="margin-top: 16px">
        <span>{{ $t('dms_changeDeviceDialog.xzsbdx') }}</span>
      </div>
      <div class="search-hd" style="padding-top: 0">
        <el-form :inline="true" @submit.native.prevent>
          <el-form-item style="float: right">
            <search-input v-model="formSearch.search" :placeholder="$t('dms_changeDeviceDialog.ji_shen_haoModemSN')"
              @fetch="onPageChange({ page: 1 })"></search-input>
          </el-form-item>
          <el-form-item style="float: right">
            <switch-button :link="$refs.container"></switch-button>
          </el-form-item>
        </el-form>
      </div>
      <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter()">
        <el-form :inline="true" label-position="top">
          <el-form-item :label="$t('dms_changeDeviceDialog.ru_ku_shi_jian')">
            <custom-date-picker style="width: 100%" v-model="dataTimes" @change="onPageChange({ page: 1 })"
              type="daterange" value-format="YYYY-MM-DD HH:mm:ss" :picker-options="beforeToday"></custom-date-picker>
          </el-form-item>
          <el-form-item :label="$t('dms_changeDeviceDialog.ku_cun_fang')">
            <el-input v-model="formSearch.orgName" :placeholder="$t('dms_changeDeviceDialog.ku_cun_fang')" clearable></el-input>
          </el-form-item>
        </el-form>
      </switch-container>
      <div class="table-bd">
        <custom-table height="400px" type="radio" v-model="selectRow" tableCode="stockChange" :data="tableList" @filter="filterChange"
          @sort="sortChange" :filterArr="['returnOrg']"></custom-table>
      </div>
      <div class="table-page">
        <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize"
          @change="onPageChange"></custom-page>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="primary" @click="confirm">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  components: {},
  data() {
    return {
      selectRow: {},
      rowTableList: [],
      dataTimes: [],
      form: {
        newBodyNum: '',
        oldBodyNum: '',
        oldConsigneeOrgId: '',
      },
      formSearch: {
        isSwapDevice: 1,
        oldProductBrand: '',
        consigneeOrgId: '',
        oldBodyNum: '',
        productCode: '',
        stockOrgId: '',
        startTime: '',
        endTime: '',
        search: '',
        // 库存方
        orgName: '',
        pageSize: 20,
        pageNum: 1,
      },
      tableList: [],
      totalRows: 0,
    };
  },
  mounted() {
    this.initDialog();
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.rowTableList = [this.model.row];
      this.form.oldBodyNum = this.model.row.bodyNum;
      this.formSearch.consigneeOrgId = this.model.row.orgId;
      this.formSearch.oldProductBrand = this.model.row.productBrand;
      this.formSearch.productCode = this.model.row.productCode;
      this.formSearch.oldBodyNum = this.model.row.bodyNum;
      this.resetFormSearch = JSON.stringify(this.formSearch);
      this.getTableList();
    },
    // 确认保存
    confirm: function () {
      if (!this.form.oldConsigneeOrgId) {
        this.$message.error(this.$t('dms_changeDeviceDialog.qxzfhzz'));
        return;
      }
      if (!this.selectRow.bodyNum) {
        this.$message.error(this.$t('dms_changeDeviceDialog.qxzxsb'));
        return;
      }
      this.form.newBodyNum = this.selectRow.bodyNum;
      this.$postJSON(apis.stockSwap, this.form, true).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.$emit('success');
        this.visible = false;
      });
    },
    // 获取表格数据列表
    getTableList: function () {
      this.formSearch.startTime = this.dataTimes ? this.dataTimes[0] : '';
      this.formSearch.endTime = this.dataTimes ? this.dataTimes[1] : '';
      this.$getJSON(apis.stockTransferPage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 清除
    clearFilter: function () {
      this.dataTimes = [];
      this.formSearch = JSON.parse(this.resetFormSearch);
      this.onPageChange({ page: 1 });
    },
  },
};
</script>

<style lang="scss"></style>
